module.exports = __webpack_public_path__ + "static/media/facebook.8f5ce275.png";